import { useEffect, useState } from "react";
import database from "../config/FirbaseConfig";

import { parsePhoneNumberFromString, getCountries, getCountryCallingCode } from "libphonenumber-js";

const countryList = getCountries().map((country) => ({
  code: country,
  dialCode: "+" + getCountryCallingCode(country),
}));

const LoginAndProfilePopup = ({ logo }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [userData, setUserData] = useState(localStorage.getItem("loggedInUser")
    ? JSON.parse(localStorage.getItem("loggedInUser"))
    : {
      name: "",
      country: "IN",
      phoneDigits: "",
    }
  );

  useEffect(() => {
    const lastPrompt = localStorage.getItem("lastPromptforLogin");
    if (!lastPrompt || Date.now() - Number(lastPrompt) > 3600000) {
      setOpen(true);
      localStorage.setItem("lastPromptforLogin", Date.now().toString());
    }
  }, []);

  const validatePhone = () => {
    try {
      const phoneNumber = parsePhoneNumberFromString(
        userData.phoneDigits,
        userData.country
      );

      if (!phoneNumber || !phoneNumber.isValid()) {
        return null;
      }

      return {
        fullPhone: phoneNumber.number, // +919876543210
        country: phoneNumber.country,  // IN
        countryCode: "+" + phoneNumber.countryCallingCode, // +91
        phoneDigits: phoneNumber.nationalNumber // 9876543210
      };
    } catch {
      return null;
    }
  };

  const saveUser = async () => {
    if (loading) return;
    setError("");

    if (!userData.name.trim()) {
      setError("Name is required");
      return;
    }

    const phoneData = validatePhone();

    if (!phoneData) {
      setError("Please enter a valid phone number");
      return;
    }

    const phoneKey = phoneData.fullPhone.replace("+", "");

    setLoading(true);

    try {
      const userRef = database.ref(`Users/${phoneKey}`);
      const snap = await userRef.once("value");
      const existing = snap.exists() ? snap.val() : null;

      await userRef.set({
        name: userData.name,
        country: phoneData.country,
        countryCode: phoneData.countryCode,
        phoneDigits: phoneData.phoneDigits,
        fullPhone: phoneData.fullPhone,
        createdAt: existing?.createdAt || Date.now(),
        lastModifiedAt: Date.now(),
      });

      localStorage.setItem(
        "loggedInUser",
        JSON.stringify({
          name: userData.name,
          country: phoneData.country,
          countryCode: phoneData.countryCode,
          phoneDigits: phoneData.phoneDigits,
          fullPhone: phoneData.fullPhone
        })
      );

      setOpen(false);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (!open) {
    return (
      <div
        onClick={() => setOpen(true)}
        style={floatingBtn}
      >
        {userData?.gender === "Female" ? <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#FFFFFF"><path d="M391-480q-36 0-60-27t-19-63l13-98q8-57 52-94.5T480-800q59 0 103 37.5t52 94.5l13 98q5 36-19 63t-60 27H391Zm0-80h178l-13-96q-4-28-25.5-46T480-720q-29 0-50.5 18T404-656l-13 96Zm89 0ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240 0Z" /></svg> :
          <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#001E3A"><path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z" /></svg>}

      </div>
    );
  }

  return (
    <div style={popupStyle}>
      <img src={logo} alt="logo" style={{ width: 50, height: 50, objectFit: "contain" }} />
      <button onClick={() => setOpen(false)} style={closeBtn}>
        ✕
      </button>

      <input
        placeholder="Name"
        value={userData.name}
        onChange={(e) =>
          setUserData({ ...userData, name: e.target.value })
        }
        style={inputStyle}
      />

      <div style={phoneRow}>
        <select
          value={userData.country}
          onChange={(e) =>
            setUserData({ ...userData, country: e.target.value })
          }
          style={countrySelect}
          defaultValue={'IN' || ""}
        >
          {countryList.map((c) => (
            <>
              {console.log("Country in dropdown:", c)}
              <option key={c.code} value={c.code}>
                {c.code} {c.dialCode}
              </option>
            </>
          ))}
        </select>

        <input
          placeholder="Phone Number"
          value={userData.phoneDigits}
          onChange={(e) =>
            setUserData({ ...userData, phoneDigits: e.target.value })
          }
          style={phoneInput}
        />
      </div>

      {error && <div style={errorStyle}>{error}</div>}

      <button
        style={{ ...btnStyle, opacity: loading ? 0.7 : 1 }}
        onClick={saveUser}
        disabled={loading}
      >
        {loading ? "Saving..." : "Save"}
      </button>
    </div>
  );
};
/* Styles */

const phoneRow = {
  display: "flex",
  gap: 8,
  marginTop: 10,
};

const countrySelect = {
  width: "30%",
  padding: 10,
  borderRadius: 12,
  border: "1px solid #ccc",
  fontSize: 13,
};

const phoneInput = {
  width: "70%",
  padding: 10,
  borderRadius: 12,
  border: "1px solid #ccc",
};

const popupStyle = {
  position: "fixed",
  bottom: "50%",
  left: "50%",
  transform: "translate(-50%, 50%)",
  width: "80vw",
  padding: "30px 25px 25px 25px",
  background: "#fff",
  borderRadius: 25,
  boxShadow: "0 0 50px #00000099",
  zIndex: 1000,
};

const floatingBtn = {
  position: "fixed",
  bottom: "15px",
  left: 20,
  width: 65,
  height: 65,
  borderRadius: "50%",
  backgroundColor: "#fff",
  boxShadow: "inset 1px 1px 1vh #ffffff85, 1px 2px 2vw #001E3A99",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  zIndex: 1000,
};

const closeBtn = { float: "right", border: "none", background: "none" };

const inputStyle = {
  width: "100%",
  padding: 10,
  marginTop: 10,
  borderRadius: 12,
  border: "1px solid #ccc",
};

const btnStyle = {
  width: "100%",
  padding: 12,
  borderRadius: 15,
  fontWeight: "700",
  border: "none",
  background: "#395B64",
  color: "#fff",
  marginTop: 15,
};

const errorStyle = {
  color: "#FF0000",
  fontSize: 12,
  marginTop: 6,
};

export default LoginAndProfilePopup;